import { Controller } from "@hotwired/stimulus"

// Cloudflare Turnstile widget (the contact form's robot check). Loads
// Cloudflare's script once, in explicit mode, and renders the widget on
// connect, so it also appears after a Turbo visit. The widget adds a hidden
// cf-turnstile-response field to the form; TurnstileVerifier checks it.
const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
let scriptPromise

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile)

  scriptPromise ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = SCRIPT_URL
    script.async = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = () => {
      scriptPromise = null
      reject(new Error("Turnstile script failed to load"))
    }
    document.head.appendChild(script)
  })
  return scriptPromise
}

export default class extends Controller {
  static values = { sitekey: String }

  async connect() {
    try {
      const turnstile = await loadTurnstile()
      if (!this.element.isConnected) return

      this.widgetId = turnstile.render(this.element, {
        sitekey: this.sitekeyValue,
        language: "es",
        theme: document.documentElement.dataset.theme === "dark" ? "dark" : "light"
      })
    } catch (error) {
      console.warn(error)
    }
  }

  disconnect() {
    if (this.widgetId !== undefined && window.turnstile) window.turnstile.remove(this.widgetId)
    this.widgetId = undefined
  }
}
